import * as server from '../entries/pages/admin/order/_id_integer_/_page.server.ts.js';

export const index = 29;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/admin/order/_id_integer_/_page.svelte.js')).default;
export { server };
export const server_id = "src/routes/admin/order/[id=integer]/+page.server.ts";
export const imports = ["_app/immutable/nodes/29.CKkSmzhs.js","_app/immutable/chunks/Bzak7iHL.js","_app/immutable/chunks/CnGaPG_y.js","_app/immutable/chunks/DIeogL5L.js","_app/immutable/chunks/BBilxCvN.js","_app/immutable/chunks/7JdHMB9Z.js","_app/immutable/chunks/BqhvobEz.js","_app/immutable/chunks/_bkH3ryn.js","_app/immutable/chunks/Bu9wkQ5s.js","_app/immutable/chunks/Dvhcax_L.js","_app/immutable/chunks/Dsy9VFq4.js","_app/immutable/chunks/CAN0e4T3.js"];
export const stylesheets = [];
export const fonts = [];
